export default "__VITE_ASSET__C_aCnTF4__"